import { argbFromHex } from '@material/material-color-utilities'
import clsx from 'clsx'

import { ChevronDown } from '@makyoapp/makyo-icon/icon'
import { useTheme } from '@makyoapp/makyo-ui'

import { getThemeHexColorScheme, themeFromMultiSource } from '@/shared/brand-kit'

export function BrandColorOption({ opt, inToggle }: { opt: { name: string; color: string }; inToggle: boolean }) {
  const { state: themeState } = useTheme()
  const mode = themeState.mode
  const theme = themeFromMultiSource([argbFromHex(opt.color)])
  const scheme = getThemeHexColorScheme(theme, mode)
  return (
    <div className='py-2 flex-c w-full'>
      <div className='w-full'>
        <div className='mb-2 flex-c'>
          <div>{opt.name}</div>
          {inToggle && <ChevronDown />}
        </div>
        <div className='w-full flex-c'>
          <div className={clsx('inline-flex w-full rounded-sm overflow-hidden')}>
            {Object.entries(scheme).map(([k, v], i) => {
              return <div key={i} className='w-full h-6' title={k} style={{ background: v }} />
            })}
          </div>
          {!inToggle && <div className='w-[11px] shrink-0 bg-red-600' />}
        </div>
      </div>
    </div>
  )
}
